import { VersionInfo } from '@/components/common';
import React from 'react';
import { useLocation } from 'react-router-dom';

const PUBLIC_VERSION_PATHS = [
  '/login',
  '/change-password',
  '/registration',
  '/rfid-activation',
  '/rfid-assignment',
  '/device-registration',
];

/**
 * Displays version information on public routes without modifying each page component.
 */
export const PublicVersionBadge: React.FC = () => {
  const { pathname } = useLocation();

  const isPublicPage = PUBLIC_VERSION_PATHS.some((publicPath) => pathname.startsWith(publicPath));

  if (!isPublicPage) {
    return null;
  }

  return (
    <div className="public-version-badge">
      <VersionInfo variant="floating" />
    </div>
  );
};
